class ListCards {
    constructor() {
        this.sectionListCards = document.querySelector('.list-cards');
        this.itemsContainer = document.querySelector('.list-cards__items');
        this.moreButton = document.querySelector('.list-cards__more');
        this.totalPosts = this.sectionListCards && this.sectionListCards.getAttribute('data-total-posts')
        this.postType = this.sectionListCards && this.sectionListCards.getAttribute('data-post-type')
        this.postId = this.sectionListCards && this.sectionListCards.getAttribute('data-post-id')
        this.postPerPage = this.sectionListCards && this.sectionListCards.getAttribute('data-post-per-page')
        this.page = 1;
        this.init();
    }

    init() {
        this.clickHandle();
    }

    clickHandle() {
        this.moreButton && this.moreButton.addEventListener('click', () => {
            this.ajax();
        })
    }

    ajax() {
        fetch(backendData.ajaxUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: new URLSearchParams({
                action: 'list_cards',
                page: this.page++,
                totalPosts: this.totalPosts,
                postType: this.postType,
                postId: this.postId,
                postPerPage: this.postPerPage,
            })
        }).then((response) => {
            response.json().then((resp) => {
                this.itemsContainer && this.itemsContainer.insertAdjacentHTML('beforeend', resp.cards);
                if (resp.isLastPage) {
                    this.moreButton.style.display = 'none';
                }
            })
        })
    }
}

new ListCards();